import { LocationFilterButton } from "../../../features/filters/LocationFilterButton";
import { FilterContainer } from "../../../styles/container";
import { VenuesFilterInfo } from "../VenuesScreen";
import {
  ITEM_VERTICAL_SPACING,
  LINE_VERTICAL_SPACING,
} from "../../../styles/spacing";
import Skeleton from "react-loading-skeleton";
import { getBorderRadius } from "../../../utils";
import { CourtTypeFilterButton } from "../../../features/filters/CourtTypeFilterButton";
import { CourtType, VerificationStatusFilter } from "../../../types/enums";
import { LightingFilterButton } from "../../../features/filters/LightingFilterButton";
import { VerificationStatusFilterButton } from "../../../features/filters/VerificationStatusFilterButton";

type VenuesFilterSectionProps = {
  filterInfo?: VenuesFilterInfo;
};

export const VenuesFilterSection = (props: VenuesFilterSectionProps) => {
  const { filterInfo } = props;
  return (
    <>
      <FilterContainer
        style={{
          marginTop: ITEM_VERTICAL_SPACING,
          marginBottom: LINE_VERTICAL_SPACING,
        }}
      >
        {filterInfo ? (
          <LocationFilterButton
            latitudeFilter={filterInfo.latitudeFilter}
            longitudeFilter={filterInfo.longitudeFilter}
            mileageFilter={filterInfo.mileageFilter}
            address={filterInfo.address}
            displayAddress={filterInfo.displayAddress}
            setLatitudeFilter={filterInfo.setLatitudeFilter}
            setLongitudeFilter={filterInfo.setLongitudeFilter}
            setMileageFilter={filterInfo.setMileageFilter}
            setAddress={filterInfo.setAddress}
            setDisplayAddress={filterInfo.setDisplayAddress}
            defaultLocation={filterInfo.userLocation}
          />
        ) : (
          <div style={{ width: 150 }}>
            <Skeleton
              height={32}
              borderRadius={getBorderRadius("large", "rounded rect")}
            />
          </div>
        )}
        <div style={{ width: 8 }} />
        {filterInfo ? (
          <CourtTypeFilterButton
            value={filterInfo.courtTypeFilter}
            setValue={filterInfo.setCourtTypeFilter}
            defaultValue={CourtType.Any}
          />
        ) : (
          <div style={{ width: 150 }}>
            <Skeleton
              height={32}
              borderRadius={getBorderRadius("large", "rounded rect")}
            />
          </div>
        )}
        <div style={{ width: 8 }} />
        {filterInfo ? (
          <LightingFilterButton
            value={filterInfo.lightingFilter}
            setValue={filterInfo.setLightingFilter}
            defaultValue={CourtType.Any}
          />
        ) : (
          <div style={{ width: 150 }}>
            <Skeleton
              height={32}
              borderRadius={getBorderRadius("large", "rounded rect")}
            />
          </div>
        )}
        <div style={{ width: 8 }} />
        {filterInfo ? (
          <VerificationStatusFilterButton
            value={filterInfo.verificationStatusFilter}
            setValue={filterInfo.setVerificationStatusFilter}
            defaultValue={VerificationStatusFilter.Any}
          />
        ) : (
          <div style={{ width: 150 }}>
            <Skeleton
              height={32}
              borderRadius={getBorderRadius("large", "rounded rect")}
            />
          </div>
        )}
      </FilterContainer>
    </>
  );
};
